import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { PartnerAnalysisGroup5 } from '../../entities/control-tables/partner-analysis-group5';

export class PartnerAnalysisGroup5Request extends BaseRequest {

    partnerAnalysisGroup5 : PartnerAnalysisGroup5

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.partnerAnalysisGroup5 = new PartnerAnalysisGroup5()
  }
}